import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent {

  searchString: any = '';
  sortby: any = 'pltNo';
  pltData: any;
  plotDetails: any;

  constructor(
    private SharedService: SharedService,
    private router: Router  ) {

  }

  ngOnInit(): void {

    this.SharedService.assetsList().subscribe((response) => {
      console.log(response);
      this.pltData = response;
    })



  }



  info(id: any): any {
    this.pltData.forEach(plot => {
      if (plot.plot_number == id) {
        this.plotDetails = plot;
        document.getElementById("sales-info-btn").click();
      }
    });

  }


}
